module.exports = __webpack_public_path__ + "img/brand_logo_chrysler.3d3b1804.png";